// extracted by mini-css-extract-plugin
export var button = "partner-code-tile-module--button--IhPer";
export var buttons = "partner-code-tile-module--buttons--1Wh1M";
export var rightButtonsWrapper = "partner-code-tile-module--right-buttons-wrapper--av+WM";
export var termButton = "partner-code-tile-module--term-button--usnY9";